import { Routes } from '@angular/router';
import { BoondockEditComponent } from './boondock-edit/boondock-edit.component';
import { ListingEditComponent } from './listing-edit/listing-edit.component';
import { ListingListComponent } from './listing-list/listing-list.component';

export const LISTINGS_ROUTES: Routes = [
  { path: '', pathMatch: 'full', component: ListingListComponent },
  {
    path: 'boondocking/new',
    pathMatch: 'full',
    component: BoondockEditComponent,
    data: {
      title: 'New Boondock',
    },
  },
  {
    path: 'boondocking/edit/:id',
    pathMatch: 'full',
    component: BoondockEditComponent,
    data: {
      title: 'Edit Boondock',
    },
  },
  {
    path: 'new',
    pathMatch: 'full',
    component: ListingEditComponent,
    data: {
      title: 'New Site',
    },
  },
  {
    path: 'edit/:id',
    pathMatch: 'full',
    component: ListingEditComponent,
    data: {
      title: 'Edit Site',
    },
  },
];
